import React, { useCallback } from "react";
import PropTypes from "prop-types";

import ACL_RELATIONSHIPS from "acl-relationships";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import EntityService from "services/Entity";
import { useDepartmentsTable } from "hooks/useDepartmentsTable";
import { DepartmentModal } from "routes/entity/components/DepartmentsModals";

const NewDepartmentButton = withRoleCheck(DepartmentModal.NewButton, [
  ACL_RELATIONSHIPS.entityDepartment.create,
]);

export const DEPARTMENTS_TABLE_CONSTANTS = {
  tableName: "departments",
  className: "Departments",
  headerIcon: "building",
  header: "Departments",
};

const DepartmentsTableV3 = ({ entityId }) => {
  const { columns, queryKey, departmentModalRef, invalidateData } =
    useDepartmentsTable({
      entityId,
    });

  const fetchDepartments = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        let response = await EntityService.getDepartmentsTable(
          entityId,
          nextQueryParams
        );

        return response;
      } catch (error) {
        console.error("Error fetching departments:", error);
        throw error;
      }
    },
    [columns, entityId]
  );

  return (
    <>
      <DepartmentModal
        ref={departmentModalRef}
        entityId={entityId}
        onSuccess={invalidateData}
      />
      <BaseTableV3
        columns={columns}
        queryKey={queryKey}
        className={DEPARTMENTS_TABLE_CONSTANTS.className}
        tableName={DEPARTMENTS_TABLE_CONSTANTS.tableName}
        header={DEPARTMENTS_TABLE_CONSTANTS.header}
        headerIcon={DEPARTMENTS_TABLE_CONSTANTS.headerIcon}
        fetchData={fetchDepartments}
        invalidateData={invalidateData}
        createButton={<NewDepartmentButton modalRef={departmentModalRef} />}
      />
    </>
  );
};

DepartmentsTableV3.propTypes = {
  entityId: PropTypes.number.isRequired,
};

export default DepartmentsTableV3;
